type EventHandler = (event: Event) => void;

/**
 * Use @PreventDefault to prevent the default behavior of an event that is passed as parameter to a method.
 */
export function PreventDefault() {
  return function (target, propertyKey, descriptor: TypedPropertyDescriptor<EventHandler>): TypedPropertyDescriptor<EventHandler> {
    const originalMethod = descriptor.value;

    descriptor.value = function (event: Event) {
      event.preventDefault();
      return originalMethod.apply(this, [event]);
    };

    return descriptor;
  };
}

/**
 * Use @StopPropagation to stop the propagation of an event that is passed as parameter to a method.
 */
export function StopPropagation() {
  return function (target, propertyKey, descriptor: TypedPropertyDescriptor<EventHandler>): TypedPropertyDescriptor<EventHandler> {
    const originalMethod = descriptor.value;

    descriptor.value = function (event: Event) {
      event.stopPropagation();
      return originalMethod.apply(this, [event]);
    };

    return descriptor;
  };
}
